import React from "react";
import { Table } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import individualStatsStyles from "../styles/IndividualStats.styles";
import NoDataBox from "../../common/components/NoDataBox";

const IndividualStatsTable = ({
	rows,
	columns,
	defaultValue = "-",
	title,
	statFilterField
}) => {
	const classes = individualStatsStyles();
	const filteredRows = rows
		.filter((ps) => ps[statFilterField] && ps[statFilterField].hasStats)
		.map((ps) => ({
			...ps[statFilterField],
			fullName: ps.fullName,
			uniform: ps.uniform
		}));

	return (
		<Box>
			<Typography variant="h5" className={classes.sectionTitle}>
				{title}
			</Typography>
			{filteredRows.length === 0 ? (
				<NoDataBox />
			) : (
				<Table
					columns={[
						...columns.map((column) => ({
							label: <span className={classes.tableHeader}>{column.name}</span>,
							component: ({ data }) => column.func(data) || defaultValue,
							align: column.align,
							alignHeader: column.alignHeader
						}))
					]}
					sortField=""
					rows={filteredRows}
					hidePagination
				/>
			)}
		</Box>
	);
};

export default IndividualStatsTable;
